export const labels = {
	connectedAs: {
		label: "Label.MobileCreator.PhotoSource.ConnectedAs",
		default: "Connected as {0}",
		// description: "Eg. 'Connected as Mark Zuckerberg'",
		// 0: "User name for which the user is connected with the photo source (eg. Facebook, Instagram, ...)",
	},
	myDevice: {
		label: "Label.MobileCreator.PhotoSource.MyDevice",
		default: "My device",
		// description: "Short label displayed below icon. Triggers a file input dialog to choose photos from your mobile device."
	},
};
